import { createSlice } from "@reduxjs/toolkit";

// Utility Service
import { getToken, getUser } from '../utils/AuthService';

const initialState = {
    token: getToken(),
    user: getUser(),
    footerVisibility: false
};

export const userSlice = createSlice({
    name: "User",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setFooterVisibility: (state, action) => {
            state.footerVisibility = action.payload;
        }
    }
});

export const {
    setToken,
    setUser,
    setFooterVisibility
} = userSlice.actions;

export const selectToken = (state) => state.user.token;
export const selectUser = (state) => state.user.user;
export const selectFooterVisibility = (state) => state.user.footerVisibility;

export default userSlice.reducer;